<template>
    <div id="basketWindow" class="abs">
        <loader :color="'rgba(255,255,255,0.8)'" :size="30" :loading="loading"></loader>
        <div class="basketList">
            <div class="basketItem" v-for="basket in getMenuList" :key="basket.id">
                <router-link class="basketName pointer" tag="a" :to="'/basket/basket-list-items/' + basket.id">{{ basket.name }}</router-link>
                <span class="countArticles" :class="{ active: basket.isCurrent }">{{ basket.nbItems }}</span>
                <div class="basketActions iBlock vMid">
                    <router-link class="viewBasket pointer" tag="a" :to="'/basket/basket-list-items/' + basket.id">{{
                        $t("basketMenu.viewBasket")
                    }}</router-link>
                    <span :id="basketInfoId(basket)" class="roundedIcon pointer"> <i class="fas fa-info"></i></span>
                    <b-tooltip container="basketWindow" :target="basketInfoId(basket)" placement="right">
                        <div class="basketInfoToolTip">
                            <span>C : {{ basket.createdAt }} by {{ basket.createdBy.firstname + " " + basket.createdBy.lastname }} </span>
                            <span>M : {{ basket.modifiedDate }} by {{ basket.modifiedBy.firstname + " " + basket.modifiedBy.lastname }} </span>
                        </div>
                    </b-tooltip>
                    <span class="roundedIcon pointer" @click="deleteBasketPrompt(basket)"><i class="fas fa-trash-alt"></i></span>
                </div>
            </div>
            <div v-if="countAllBaskets < 1">{{ $t("basketMenu.noBasket") }}</div>
        </div>
        <footer v-if="countAllBaskets > 5">{{ $t("basketMenu.viewAllBaskets") }} ({{ countAllBaskets }})</footer>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import loader from "../../components/loader/loader";
import { BTooltip } from "bootstrap-vue";

export default {
    name: "Basketwindow",
    components: { loader, "b-tooltip": BTooltip },
    data() {
        return {
            loading: false
        };
    },
    computed: {
        ...mapGetters("basket/list", {
            countAllBaskets: "countAllBaskets",
            getMenuList: "getMenuList"
        })
    },
    methods: {
        ...mapActions("basket/list", {
            populateBasketList: "populateBasketList",
            deleteBasket: "deleteBasket"
        }),
        basketInfoId(basket) {
            return "menuInfoButton" + basket.id;
        },
        async load() {
            try {
                this.loading = true;
                await this.populateBasketList();
            } finally {
                this.loading = false;
            }
        },
        async deleteBasketPrompt(basket) {
            await this.$swal({
                title: this.$t("basketMenu.warning"),
                text: this.$t("basketMenu.deleteConfirmation").replace("{basket}", basket.name),
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "red",
                confirmButtonText: this.$t("basketMenu.deleteAction"),
                cancelButtonText: this.$t("basketMenu.cancelAction"),
                closeOnConfirm: true
            });
            this.deleteBasket(basket.id);
        }
    },
    mounted() {
        this.load();
    }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/themes.scss";
#basketWindow {
    left: 50%;
    top: 50px;
    min-width: 350px;
    @extend %second-background;
    @extend %second-text;
    transform: translate(-50%, 0%);
    z-index: 500;
    a {
        color: inherit;
        text-decoration: none;
    }
    .basketList {
        padding: 10px;
        .basketItem {
            font-family: Oswald;
            border-bottom: 1px solid #000;
            @extend %second-border-color;
            padding: 8px 5px;
            font-size: 17px;
            &:last-child {
                border: none;
            }
            .countArticles {
                background-color: darkgray;
                display: inline-block;
                border-radius: 5px;
                padding: 1px 7px;
                color: #ffffff;
                font-size: 11px;
                vertical-align: middle;
                margin-left: 10px;
                &.active {
                    background-color: forestgreen;
                }
            }
            .basketActions {
                float: right;
                margin-left: 50px;
                .viewBasket {
                    font-size: 9px;
                    border: 1px #000 solid;
                    @extend %second-border-color;
                    padding: 0px 7px;
                    border-radius: 5px;
                    text-transform: uppercase;
                }

                .roundedIcon {
                    font-size: 10px;
                    width: 17px;
                    height: 17px;
                    line-height: 17px;
                }
            }
        }
    }
    footer {
        background-color: #333;
        text-align: right;
        color: #fff;
        font-size: 11px;
        padding: 5px;
    }
    .basketInfoToolTip {
        background-color: #000;
        color: #ffffff;
        padding: 6px;
        span {
            text-transform: inherit;
            display: block;
            font-size: 12px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// BasketWindow.vue?3280c67c